export default __webpack_public_path__ + "static/media/pic1.80706f5d.jpg";